export default "__VITE_ASSET__2d2c3372__"